import { useEffect, useState } from "react";

import { ISSERVER } from "../utils/isServer";

const isClient = !ISSERVER;

export const useIsOnline = () => {
  const [isInternetAvailable, setIsInternetAvailable] = useState<boolean>(true);

  useEffect(() => {
    setIsInternetAvailable(window.navigator.onLine);
  }, [isClient]);

  useEffect(() => {
    const handleOnlineStatus = () => setIsInternetAvailable(true);
    const handleOfflineStatus = () => setIsInternetAvailable(false);

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOfflineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
    };
  }, []);

  return { isInternetAvailable };
};
